module.exports = __webpack_public_path__ + "media/images/icons/professional-31f471b4819ad4b2d2dd0d363a8f7a2c.svg";